import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/providers.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/AppRouterPageView.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/CookieConsentBanner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/DeferredThirdParty.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/styles/shared.module.css");
;
import(/* webpackMode: "eager" */ "/app/styles/layout.css");
;
import(/* webpackMode: "eager" */ "/app/styles/custom-properties.css");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/styles/global-styled.css");
